<template>
  <div class="reservation-order-page">
    <el-form :model="ruleForm" ref="ruleForm">
      <div class="form-box">
        <el-form-item>
          <el-input style="width: 150px" v-model="ruleForm.name" placeholder="客户姓名或电话"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select style="width: 150px" v-model="ruleForm.hallId" placeholder="宴会厅">
            <el-option v-for="item in ballroomList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select style="width: 150px" v-model="ruleForm.category" placeholder="宴会类型">
            <el-option v-for="item in categories" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select style="width: 150px" v-model="ruleForm.customerManager" placeholder="客户经理">
            <el-option v-for="item in customerManagers" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker style="width: 150px" v-model="ruleForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker style="width: 150px" v-model="ruleForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item style="width: 300px;">
          <el-button @click="getReserveOrders" size="mini" type="primary">搜索</el-button>
          <el-button type="primary" style="margin: 0 30px; " size="mini" @click="exportExcel">导出</el-button>
          <el-button @click="resetForm" size="mini" type="info">重置</el-button>
          <!--          <el-button type="primary">发送到邮箱</el-button>-->
        </el-form-item>
      </div>
    </el-form>
    <el-table id="selectTable" :data="tableData" height="66vh" :default-sort="{prop: 'date', order: 'descending'}" stripe style="width: 100%">
      <el-table-column align="center" type="index" label="序号" width="50">
      </el-table-column>
      <el-table-column prop="customerName" align="center" label="客户姓名">
      </el-table-column>
      <el-table-column prop="customerPhoneNumber" align="center" label="客户电话">
      </el-table-column>
      <el-table-column prop="depositsMoney" align="center" label="定金金额"/>
      <el-table-column prop="paymentItem" align="center" label="定金类型"/>
      <el-table-column prop="paymentMethod" align="center" label="支付方式"/>
      <el-table-column prop="receipt" align="center" label="收据编号"/>
<!--      <el-table-column prop="" align="center" label="收据编号">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.deposit.receiptCode}}-->
<!--        </template>-->
<!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        prop="createdAt"-->
      <!--        align="center"-->
      <!--        label="操作时间">-->
      <!--      </el-table-column>-->
      <el-table-column prop="hallName" align="center" label="宴会厅">
      </el-table-column>
      <el-table-column prop="categoryName" align="center" label="宴会类型">
      </el-table-column>
      <el-table-column prop="reserveDate" align="center" label="举办时间">
        <template slot-scope="scope">
          {{scope.row.reserveDate+'('+scope.row.reserveTimeName +')'}}
        </template>
      </el-table-column>
      <el-table-column prop="customerManager" label="客户经理" align="center"/>
      <el-table-column prop="orderStatus" label="定金状态" align="center">
        <template slot-scope="scope">
          {{scope.row.orderStatus == 0 ? "潜客" : scope.row.orderStatus == 1 ? "预留" : scope.row.orderStatus == 2 ? "已定" : ""}}
        </template>
      </el-table-column>
      <!--      <el-table-column-->
      <!--        align="center"-->
      <!--        label="详情">-->
      <!--        <template  slot-scope="scope">-->
      <!--          <el-button size="mini" @click="getBallroomData(scope.row)" type="text">详情</el-button>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
    </el-table>
    <el-pagination class="pagination" background layout="prev, pager, next" :total="total" :page-size="pageSize" @current-change="onCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
import htmlToExcel from '@/utils/htmlToExcel'
import { export_json_to_excel } from '@/utils/Export2Excel'
let org = {}
if (window.localStorage.getItem('orgs')) {
  org = JSON.parse(window.localStorage.getItem('orgs'))[0]
}
const pageSize = 10 // 每页的数量
let pageNum = 1 // 当前页
const data = {}
export default {
  name: 'PrepaidFee',
  data() {
    return {
      loading: true,
      elegantRoomVisible: false,
      ruleForm: {
        // 查询表单
        hotelBizId: this.$store.state.hotellist[0].bizId,
        hallBizId: '',
        categorySelectedBizId: '',
        customerManager: '',
        startDate: '',
        endDate: '',
        customerManagerSelectedBizId: ''
      },
      details: {},
      tableData: [], // 宴会预留订单数据
      ballroomList: [], // 宴会厅
      categories: [], // 宴会厅类型
      customerManagers: [], // 客户经理
      total: 0, // 总条数
      pageSize: pageSize // 一页要显示的条数
    }
  },
  methods: {
    // 导出
    // exportExcel() {
    //   htmlToExcel.getExcel('#selectTable', '预收款统计')
    // },
    exportExcel() {
      this.$confirm('确定要导出当前数据？', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.getExpportData()
        })
        .catch(() => {})
    },
    // 导出数据-- 执行导出
    getExpportData: function() {
      var self = this
      // --页面查询条件
      const data = {
        pageSize: 100000,
        pageNumber: 1,
        ...this.ruleForm,
        paymentVerifyMode: 1
      }
      // --导出过程中等待动作
      const loading = this.$loading({
        lock: true,
        text: '正在导出，请稍等......',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      this.getRequest('banquest-reserve/getPage', data)
        .then(res => {
          // 关闭等待
          loading.close()
          // --查询完成
          if (res.status === 200 && res.pageModel.records.length > 0) {
            require.ensure([], () => {
              const tHeader = [
                '序号',
                '客户姓名',
                '联系电话',
                '定金金额',
                '定金类型',
                '支付方式',
                '收据编号',
                '宴会厅',
                '宴会类型',
                '举办时间',
                '客户经理',
                '定金状态'
              ]
              const filterVal = [
                'index',
                'customerName',
                'customerPhoneNumber',
                'amount',
                'payCategory',
                'payMode',
                'receiptCode',
                'hallName',
                'categoryName',
                'banquetDate',
                'customerManagerName',
                'orderStatusName'
              ]
              var templist = res.pageModel.records
              var i = 1
              templist.forEach(element => {
                element.index = i++
                // if (element.reserveTableNumber) {
                //   if (element.backupTableNumber !== undefined || element.backupTableNumber !== null || element.backupTableNumber !== '') {
                //     element.reserveTableNumber = element.reserveTableNumber + '桌/备' + element.backupTableNumber + '桌'
                //   } else {
                //     element.reserveTableNumber = element.reserveTableNumber + '桌'
                //   }
                // } else {
                //   element.reserveTableNumber = ''
                // }
                element.amount = element.deposit.amount
                element.payCategory = element.deposit.payCategory
                element.payMode = element.deposit.payMode
                element.receiptCode = element.deposit.receiptCode
              })
              const data = self.formatJson(filterVal, templist)
              export_json_to_excel(tHeader, data, '预收款统计')
            })
          } else {
            this.$message({
              message: '没有有效数据!',
              duration: 2000,
              type: 'warning'
            })
          }
        })
        .catch(res => {
          // 关闭等待
          this.$message('请与管理员联系')
          loading.close()
        })
    },
    // 导出数据-- 处理数据
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    // 重置按钮
    resetForm() {
      this.ruleForm = {
        hotelBizId: this.$store.state.hotellist[0].bizId,
        categorySelectedBizId: '',
        startDate: '',
        endDate: '',
        customerManagerSelectedBizId: '',
        dateFormat: ''
      }
      this.getReserveOrders()
    },
    // 查询预定订单数据 banquetDate
    async getReserveOrders() {
      this.tableData = []
      const data = {
        pageSize: pageSize,
        pageNumber: pageNum,
        ...this.ruleForm,
        paymentVerifyMode: 1,
        sort: 'banquetDate'
      }
      console.log('查询条件：' + JSON.stringify(data))
      const res = await this.getRequest('banquest-reserve/getPage', data)

      console.log(res.data)
      this.tableData = res.data.records
      this.loading = false
      // 总数
      this.total = res.data.total
    },
    // 获取宴会厅类型
    async getBallroomType() {
      const res = await this.getRequest('banquet/loadmeta', { hotelId: org.id })
      this.ballroomList = []
      this.categories = []
      if (res.code == 200) {
        console.log(res)
        this.ballroomList = res.data.halls
        this.categories = res.data.categories
      }
    },
    // 获取宴会厅客户经理
    async getCustomerManager() {
      const res = await this.getRequest('sys/user/loadCostumerManager', {})
      this.customerManagers = []
      if (res.code == 200) {
        console.log(res)
        this.customerManagers = res.data
      }
    },
    // 宴会厅改变事件
    onBallroomChange(e) {
      this.ruleForm.categorySelectedBizId = ''
      this.categories = []
      const records = this.ballroomList.filter(i => {
        return i.bizId === e
      })
      const { categories } = records[0]
      this.categories = categories.map(o => {
        return { value: o.code, name: o.name, label: o.name, bizId: o.bizId }
      })
    },
    // 分页事件
    onCurrentChange(val) {
      pageNum = val
      this.getReserveOrders()
    },
    // 查看详情
    getBallroomData(row) {
      // console.log('查看详情')
    },
    // 转为预定
    onReserve() {
      this.$router.push({
        path: '/banquet/reserve',
        query: {
          ...data
        }
      })
    }
  },
  mounted() {
    this.getReserveOrders()
    this.getBallroomType()
    this.getCustomerManager()
    if (this.$route.query.q) {
      const { hallBizId, bizId } = this.$store.state.banquetReservation
      const row = {
        hallBizId,
        bizId
      }
      this.getBallroomData(row)
    }
  }
}
</script>

<style lang="scss" scoped>
.reservation-order-page {
  box-sizing: border-box;
  padding: 10px;
  overflow: auto;
  position: relative;
  .form-box {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    margin: 0;
    .el-form-item {
      margin-bottom: 15px;
      margin-right: 20px;
    }
  }
  .pagination {
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
  .order-details {
    height: auto;
    margin-top: -30px;
    margin-bottom: -20px;

    .customer-details {
      height: 120px;
      margin-bottom: 20px;
      .title {
        //margin: 5px 0;
        //margin-top: -10px;
        padding: 2px 10px;
        background: #f7f6f6;
        //border: 1px solid #d4d4d4;
        background: #f7f6f6;
      }
    }
    .reserved-details {
      height: auto;
      .title {
        //margin: 5px 0;
        padding: 2px 10px;
        background: #f7f6f6;
        //border: 1px solid #d4d4d4;
      }
      .box-card {
        //border: 1px solid #ccc;
        border-radius: 5px;
        //box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        padding: 0px 5px;
        .box-card-img {
          width: 100px;
          height: 100px;
          margin-right: 10px;
          border-radius: 5px;
        }
      }
    }
  }
}
</style>
